(function () {
  const CONTAINER_SELECTOR = '[data-promotions-slider]';
  const PAGE_SELECTOR = '.drawer__promotions-page';
  const READY_ATTR = 'data-promotions-slider-ready';
  const CONTROLS_ATTR = 'data-promotions-slider-controls';
  const INIT_ATTR = 'data-promotions-slider-initialized';
  const STORED_TABINDEX_ATTR = 'data-promotions-slider-tabindex';
  const FOCUSABLE_SELECTOR = [
    'a[href]',
    'area[href]',
    'button',
    'input',
    'select',
    'textarea',
    'iframe',
    '[tabindex]',
    '[contenteditable="true"]',
    'summary',
  ].join(', ');

  const setPageState = (page, isActive) => {
    page.setAttribute('aria-hidden', String(!isActive));

    page.querySelectorAll(FOCUSABLE_SELECTOR).forEach((element) => {
      if (isActive) {
        if (element.hasAttribute(STORED_TABINDEX_ATTR)) {
          const previousTabindex = element.getAttribute(STORED_TABINDEX_ATTR);

          if (previousTabindex === '') {
            element.removeAttribute('tabindex');
          } else {
            element.setAttribute('tabindex', previousTabindex);
          }

          element.removeAttribute(STORED_TABINDEX_ATTR);
        }

        return;
      }

      if (!element.hasAttribute(STORED_TABINDEX_ATTR)) {
        element.setAttribute(STORED_TABINDEX_ATTR, element.getAttribute('tabindex') ?? '');
      }

      element.setAttribute('tabindex', '-1');
    });
  };

  const syncPages = (slider, currentPage = 1) => {
    const pages = Array.from(slider.querySelectorAll(PAGE_SELECTOR));
    const safePage = Math.min(Math.max(parseInt(currentPage, 10) || 1, 1), Math.max(pages.length, 1));

    pages.forEach((page, index) => {
      setPageState(page, index + 1 === safePage);
    });
  };

  const updateControlsState = (shell, pages) => {
    const hasMultiplePages = pages.length > 1;
    shell.setAttribute(CONTROLS_ATTR, String(hasMultiplePages));
  };

  const initContainer = (container) => {
    if (!(container instanceof HTMLElement) || container.hasAttribute(INIT_ATTR)) {
      return;
    }

    const slider = container.querySelector('slider-element');
    const shell = container.querySelector(`[${READY_ATTR}]`);

    if (!(slider instanceof HTMLElement) || !(shell instanceof HTMLElement)) {
      return;
    }

    container.setAttribute(INIT_ATTR, 'true');
    shell.setAttribute(CONTROLS_ATTR, 'false');
    syncPages(slider, slider.currentPage || 1);

    const prevButton = container.querySelector('.drawer__promotions-arrow--prev');
    const nextButton = container.querySelector('.drawer__promotions-arrow--next');

    const updateButtonDisabled = (button, status) => {
      if (!button) return;
      if (status === 'hidden') {
        button.setAttribute('disabled', '');
      } else {
        button.removeAttribute('disabled');
      }
    };

    let previousStatus = 'hidden';
    let nextStatus = 'hidden';
    let ready = false;

    const markReady = () => {
      if (ready) {
        return;
      }

      ready = true;
      shell.setAttribute(READY_ATTR, 'true');
    };

    const handleStatus = (type, event) => {
      const status = event.detail?.status || 'hidden';

      if (type === 'previous') {
        previousStatus = status;
        updateButtonDisabled(prevButton, status);
      } else {
        nextStatus = status;
        updateButtonDisabled(nextButton, status);
      }

      markReady();
      updateControlsState(shell, Array.from(slider.querySelectorAll(PAGE_SELECTOR)));
      syncPages(slider, slider.currentPage || 1);
    };

    slider.addEventListener('slider:previousStatus', (event) => {
      handleStatus('previous', event);
    });

    slider.addEventListener('slider:nextStatus', (event) => {
      handleStatus('next', event);
    });

    slider.addEventListener('slider:change', (event) => {
      syncPages(slider, event.detail?.currentPage || slider.currentPage || 1);
    });

    customElements.whenDefined('slider-element').then(() => {
      syncPages(slider, slider.currentPage || 1);

      if (typeof slider.updateButtons === 'function' && typeof slider.currentPage === 'number') {
        slider.updateButtons();
      }
    });
  };

  const scan = (root = document) => {
    if (!(root instanceof Element || root instanceof Document)) {
      return;
    }

    if (root instanceof Element && root.matches(CONTAINER_SELECTOR)) {
      initContainer(root);
    }

    root.querySelectorAll?.(CONTAINER_SELECTOR).forEach((container) => {
      initContainer(container);
    });
  };

  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node instanceof Element) {
          scan(node);
        }
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      scan(document);
      observer.observe(document.body, { childList: true, subtree: true });
    }, { once: true });
  } else {
    scan(document);
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
